<template>
  <main class="min-h-screen">
    <BurseHeader @disclaimer-toggle="handleDisclaimerToggle" />
    <ResponsiveWrapper max-width-class="max-w-none" padding-class="px-0">
      <section
        class="relative w-full bg-landingGrey"
        :class="{
          'mt-[0px]': $route.path === '/',
          'mt-[140px] md:mt-[176px]':
            $route.path !== '/' && showDisclaimerBanner,
          'mt-[60px] md:mt-[76px]':
            $route.path !== '/' && !showDisclaimerBanner,
        }"
      >
        <router-view />
        <!-- <router-view v-slot="{ Component }">
          <transition name="slide-bottom-to-top" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>   -->

        <DownloadBurse />
        <BurseFooter />
      </section>
    </ResponsiveWrapper>
  </main>
</template>

<script setup>
import { ref, onMounted } from "vue";
import BurseHeader from "../components/BurseHeader.vue";
import BurseFooter from "../components/BurseFooter.vue";
import DisclaimerBanner from "../components/landing/DisclaimerBanner.vue";
import DownloadBurse from "../components/DownloadBurse.vue";
import ResponsiveWrapper from "../components/ResponsiveWrapper.vue";
const showDisclaimerBanner = ref(true);

const handleDisclaimerToggle = (isVisible) => {
  showDisclaimerBanner.value = isVisible;
};

onMounted(() => {
  if (window.localStorage.getItem('disclaimer-banner') === 'false') {
    showDisclaimerBanner.value = false;
  }
});
</script>

<style lang="scss" scoped>
// @import url("../../styles/www.scss");

main {
  overflow-x: hidden;
  scroll-behavior: smooth;
}

.hero {
  .heading {
    color: #292a29;
  }
}

.freedom-section {
  background: #f8f8f8;

  .heading {
    font-family: "Roboto";

    span {
      color: #ea4e4b;
    }
  }
}

.what-we-offer-section {
  .heading {
    font-family: "Roboto";
  }
}

.slide-bottom-to-top-enter-active,
.slide-bottom-to-top-leave-active {
  transition: all 0.5s ease;
}

.slide-bottom-to-top-enter-from {
  // opacity: 0;
  transform: translateY(100%);
}

.slide-bottom-to-top-leave-to {
  // opacity: 0;
  transform: translateY(-100%);
}
</style>
